import { JetView } from 'webix-jet';

/**
 * Class representing the details of a bets report view.
 * @extends JetView
 */
export default class detailsBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information form structure
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Field name for ID
                    label: _("<span class='icon-id'></span> ID"), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder text
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'TransactionId', // Field name for Transaction ID
                    label: _('Transacción Id'), // Label for Transaction ID
                    labelPosition: 'top',
                    placeholder: _('Transacción Id'), // Placeholder text
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Type', // Field name for Type
                    label: _('Tipo'), // Label for Type
                    labelPosition: 'top',
                    placeholder: _('Tipo'), // Placeholder text
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Value', // Field name for Value
                    label: _('Valor'), // Label for Value
                    labelPosition: 'top',
                    placeholder: _('Valor'), // Placeholder text
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Response', // Field name for Response
                    label: _('Respuesta'), // Label for Response
                    labelPosition: 'top',
                    placeholder: _('Respuesta'), // Placeholder text
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Left main section layout
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains main_info
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true, // Allows multiple views
            scroll: true, // Enables scrolling
            cols: [left_main, { gravity: 1, minWidth: 20 }], // Columns layout
        };

        // Upper section layout for narrow screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info], // Contains main_info
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(
            this.app,
            'casinoTransDetail:select',
            (person) => form.setValues(person), // Sets form values based on selected person
        );
    }
}

// FILE DOCUMENTED
